export const messages = {
  weValue: 'We value your privacy',
  consentCookies:
    'By using this site, you consent to the cookies necessary for its basic function. Data are collected anonymously, and not sold or otherwise distributed by the proprietors of this site.',
};
